var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 176.05 40.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #f37b20;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: none;\r\n        opacity: .25;\r\n        stroke-width: .93px;\r\n      }\r\n\r\n      .cls-2, .cls-3 {\r\n        stroke: #606161;\r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .cls-3 {\r\n        stroke-width: .91px;\r\n      }\r\n\r\n      .cls-3, .cls-4 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: #606161;\r\n      }\r\n\r\n      .cls-6 {\r\n        font-family: Lato-Bold, Lato;\r\n        font-size: 13.34px;\r\n        font-weight: 700;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 17.35,
    y: 4.69,
    width: 158.25,
    height: 31.12,
    rx: 15.56,
    ry: 15.56
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(50.23 24.79)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 0,
    y: 0
  }, "Reduced "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 54.71,
    y: 0
  }, "Variability"))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 0.45,
    y: 0.45,
    width: 40.01,
    height: 40.01,
    rx: 20,
    ry: 20
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M13.06,26.63c-1.26-.76-2.36-1.66-3.36-2.69-.89-.92-1.69-1.92-2.36-3.02-.21-.35-.22-.68,0-1.02,2.1-3.31,4.89-5.81,8.64-7.08,3.42-1.15,6.81-.98,10.13.43.19.08.3.07.44-.08.82-.84,1.65-1.66,2.48-2.48.29-.28.64-.35.97-.18.31.15.53.49.45.83-.05.21-.17.44-.33.59-1.75,1.77-3.51,3.52-5.27,5.28-4.27,4.26-8.53,8.53-12.79,12.79-.46.46-.95.51-1.32.14-.37-.37-.32-.86.14-1.32.68-.68,1.36-1.36,2.04-2.04.04-.04.08-.09.14-.15ZM25.03,14.62s-.07-.04-.12-.06c-.96-.37-1.94-.61-2.96-.74-1.91-.23-3.77-.03-5.57.61-3.09,1.1-5.43,3.15-7.3,5.8-.1.14-.06.23.02.34.62.88,1.31,1.7,2.08,2.45.94.91,1.97,1.71,3.1,2.35.71-.71,1.4-1.41,2.1-2.11-1.57-2.31-.89-4.94.55-6.39,1.45-1.45,4.09-2.15,6.41-.57.56-.56,1.11-1.12,1.68-1.68ZM17.62,22.02c1.49-1.49,2.99-2.99,4.48-4.49-1.03-.71-2.77-.67-3.95.49-1.18,1.16-1.26,2.91-.53,3.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M16.35,28.04c.41-.4.81-.81,1.22-1.2.07-.06.21-.1.3-.08,4.05.84,7.62-.19,10.81-2.73,1.23-.99,2.28-2.15,3.18-3.44.1-.15.1-.24,0-.38-1-1.41-2.16-2.66-3.54-3.71-.07-.05-.13-.11-.18-.15.4-.4.79-.8,1.2-1.21.76.57,1.48,1.23,2.15,1.94.8.86,1.52,1.78,2.13,2.78.22.35.23.69,0,1.05-2.08,3.27-4.83,5.73-8.53,7.03-2.14.76-4.35.96-6.6.62-.72-.11-1.44-.28-2.15-.42,0-.03,0-.07,0-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.17,25.22c.52-.52.99-.99,1.47-1.45.06-.05.15-.08.24-.09,1.52-.18,2.69-1.36,2.89-2.89,0-.07.02-.15.06-.19.48-.48.96-.96,1.48-1.48.41,1.76.06,3.31-1.13,4.62-1.33,1.46-3.01,1.92-5.01,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M17.62,22.02c-.73-1.08-.65-2.84.53-3.99,1.18-1.16,2.92-1.2,3.95-.49-1.49,1.49-2.99,2.99-4.48,4.49Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.53983e8e7d012c032eb78eb7dd2dc950.svg";
export { ForwardRef as ReactComponent };